import { useCallback } from "react";

import * as Repository from "@/components/features/setup/model/repository";

import type * as FormModelType from "../type";

type Props = {
	inputModel: FormModelType.SetupFormModel["InputModel"];
};

export const useCreateHotel = ({ inputModel }: Props) => {
	const { onCreateHotel: _onCreateHotel } = Repository.Mutation.useSetupMutation();

	const onCreateHotel = useCallback(() => _onCreateHotel(inputModel), [inputModel, _onCreateHotel]);

	return {
		onCreateHotel,
	};
};
